import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import axios from 'axios';
import { RegistrationSlice } from '../../types/interface';

// used in the post login flow, it's meant to contain each panel's data as the user navigates through the registration form, refCode is used for the alternative option.
const initialState = {
  postLoginData: {
    firstName: '',
    lastName: '',
    address: '',
    longitude: 0,
    latitude: 0,
    calculateMetrics: true,
    selectedOrg: 'none',
    minRate: 0,
    maxRate: 1000,
    availableHours: 0,
    daysAvailable: [0, 0, 0, 0, 0, 0, 0],
    restrictionsText: '',
    initialOrgSelected: [],
    dob: '',
    phone: '',
    email: '',
    hasAgreedToTerms: false,
    wantsPromotionalEmails: false,
  },
  refCode: '',
};

const registrationSlice = createSlice({
  name: 'registration',
  initialState,
  reducers: {
    updatePostLoginForm: (state: RegistrationSlice, action: PayloadAction<{ data: any }>) => {
      console.info('FormSubmitted append data!');
      console.info(action.payload);
      state.postLoginData = {
        ...state.postLoginData,
        ...action.payload.data,
      };

      console.log(state.postLoginData);
    },
  },
  extraReducers: (builder) => {
    // refer to: https://redux-toolkit.js.org/api/createSlice
    builder.addCase(fetchOrganizationDetails.fulfilled, (state, action) => {
      console.warn('fulfilled orgFetch');
      console.log(action.payload);
    });
  },
});

//via form registration option 1
export const createUserRecord = createAsyncThunk(
  'individual/formAcreate',
  async (params: { userLookupEmail: string; details: any; token: string }) => {
    return axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/b2c/user/register/${params.userLookupEmail}`,
        params.details,
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }
      )
      .then((response) => {
        console.info('create-user response: ', response);
        return {
          status: response.status,
          message: 'successfully created account!',
          data: response.data,
        };
      })
      .catch((err) => {
        console.warn('create-user ERR: ', err.response.data.message);
        return { status: err.response.status, message: err.response.data.message };
      });
  }
);

export const fetchOrganizationDetails = createAsyncThunk(
  'registration/registrationOrgDataFetch',
  async (params: { token: string }) => {
    return axios
      .get(`${process.env.REACT_APP_SERVER_URL}/api/b2c/user/register/form-details`, {
        headers: {
          Authorization: `Bearer ${params.token}`,
        },
      })
      .then((response) => {
        console.info('orgDetailsFetch response: ', response);
        return response.data;
      })
      .catch((err) => {
        console.warn('fetch/orgDetailsFetch ERR: ', err);
      });
  }
);

export const validateReferenceCode = createAsyncThunk(
  'registration/registrationRefCodeCheck',
  async (params: {
    userLookupEmail: string;
    refCode: string;
    hasAgreedToTerms: boolean;
    wantsPromotionalEmails: boolean;
    token: string;
  }) => {
    return axios
      .put(
        `${process.env.REACT_APP_SERVER_URL}/api/b2c/user/register/validate-code/${params.userLookupEmail}`,
        {
          ref: params.refCode,
          hasAgreedToTerms: params.hasAgreedToTerms,
          wantsPromotionalEmails: params.wantsPromotionalEmails,
        },
        {
          headers: {
            Authorization: `Bearer ${params.token}`,
          },
        }
      )
      .then((response) => {
        console.info('Ref-code response: ', response);
        return response.data;
      })
      .catch((err) => {
        console.warn('Ref-code dispatch ERR: ', err);
      });
  }
);

export const fetchPostLoginData = (state: RootState) => state.registration.postLoginData!;

export const getPostLoginData = (state: RootState) => state.registration.postLoginData!;

export const { updatePostLoginForm } = registrationSlice.actions;

export default registrationSlice.reducer;
